<template>
  <v-app>
    <core-toolbar />
    <core-view />
  </v-app>
</template>
<script>
import { mapState } from 'vuex'
import CoreToolbar from '@/components/core/toolbar.vue'
import CoreView from '@/components/core/view.vue'
export default {
  components: {
    CoreToolbar,
    CoreView
  },
  data: () => ({}),
  mounted: function() {},
  computed: {
    ...mapState({
      user: state => state.user,
      base: state => state.base
    })
  },
  methods: {
    load() {
      this.base.loginuser = JSON.parse(localStorage.getItem('loginuser'))
    }
  }
}
</script>
